export const loginUser = gql`
    mutation loginUser(
        $input: LoginInput!
    ) {
        login(input: $input) {
            token
            user {
                uuid
            }
        }
    }
`
